export default __webpack_public_path__ + "static/media/preventive-treatments.82f8d1ce.svg";